import React from 'react';

const FAQItem = ({ item, isOpen, onToggle }) => {
    return (
        <div className="faq-section__item">
            <button
                className={`faq-section__question ${isOpen ? 'faq-section__question--active' : ''}`}
                onClick={() => onToggle(item.id)}
                aria-expanded={isOpen}
                type="button"
            >
                <span className="faq-section__question-text">{item.question}</span>
                <span className="faq-section__icon" aria-hidden="true">
                    {isOpen ? '\u2212' : '+'}
                </span>
            </button>

            {isOpen && (
                <div className="faq-section__answer" role="region">
                    {item.answer}
                </div>
            )}
        </div>
    );
};

export default FAQItem;
